import { createIcon } from "../create-icon"

export const SuccessIcon = createIcon({
  title: "SuccessIcon",
  viewBox: "0 0 16 16",
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.1508 3.74076C13.5701 4.10018 13.6187 4.73148 13.2593 5.15081L7.25926 12.1508C7.07798 12.3623 6.81672 12.4886 6.53838 12.4993C6.26004 12.51 5.98985 12.4041 5.79289 12.2071L2.79289 9.20712C2.40237 8.8166 2.40237 8.18344 2.79289 7.79291C3.18342 7.40239 3.81658 7.40239 4.20711 7.79291L6.44352 10.0293L11.7407 3.84923C12.1002 3.4299 12.7315 3.38134 13.1508 3.74076Z"
      fill="currentColor"
    />
  ),
})

SuccessIcon.displayName = "SuccessIcon"
